export default {
    lang: null,
    broker: null,
    currency: null,
    cacheTtl: null,
    source: null,
    headerOffset: null,

    widgetWidth: 0,

    platforms: [],
    groups: [],
    subgroups: [],
    columns: [],
    instruments: [],

    platformCode: null,
    groupId: null,
    subgroupsIds: [],
    columnsFieldsNames: [],

    filter: '',
    sortKey: null,
    sortIsAscending: true,

    columnsToShow: [],
    instrumentsToShow: [],

    platformsLoadingId: null,
    groupsLoadingId: null,
    subgroupsLoadingId: null,
    columnsLoadingId: null,
    instrumentsLoadingId: null,

    isDataLoading: false
};



// WEBPACK FOOTER //
// ./src/store/state.js